// @ts-nocheck
import '../CreatePost/CreatePost.scss'

import axios, { type AxiosRequestConfig } from 'axios'
import cn from 'classnames'
import Picker from 'emoji-picker-react'
import Lottie from 'lottie-react'
import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { isMobile, isSafari } from 'react-device-detect'
import DropboxChooser from 'react-dropbox-chooser'
import useDrivePicker from 'react-google-drive-picker'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { ReactMediaRecorder } from 'react-media-recorder'
import { QRCode } from 'react-qrcode-logo'
import { useDispatch } from 'react-redux'

import { trackEvent } from '../../../Analytics/GA'
import { environment } from '../../../AppConfig/environment'
import { socket } from '../../../AppConfig/socket'
import * as animationData from '../../../Assets/Lottie/audio-lottie.json'
import { dropbox, folder, GDrive, isset, phone } from '../../../commonservice'
import { useAppSelector } from '../../../Hooks'
import { doUpload } from '../../../Hooks/doUpload'
import { setAppError } from '../../../Redux/slices/metaSlice'
import { addPageAction } from '../../../Redux/slices/pageDetailSlice'
import { loading, setLoadItemsDone, setLoadPercentage, setShowStepStatus } from '../../../Redux/slices/userSlice'
import { store } from '../../../Redux/store'
import { createPost, updatePost } from '../../../Redux/thunks/postThunk'
import { updateUserInfo } from '../../../Redux/thunks/settingsThunk'
import Loader from '../../Loader/Loader'
import AudioWaves from '../../Shared/AudioWaves'
import PhoneInputWithCode from '../../Shared/PhoneInput'

const VideoPreview = (data: any) => {
  const stream: any = data?.stream
  const videoRef: any = useRef(null)

  useEffect(() => {
    if (videoRef?.current && stream) {
      videoRef.current.srcObject = stream
    }
  }, [stream])
  if (!stream) {
    return null
  }
  return <video ref={videoRef} height={300} width={470} autoPlay />
}

const CreateArticle = (props: any) => {
  const dispatch = useDispatch()
  const stopVideo: any = useRef(null)
  const { ismediapost } = props

  const userData: any = useAppSelector((state: any) => state?.user)
  const pageData: any = useAppSelector((state: any) => state?.pagedetail)
  const postData: any = useAppSelector((state: any) => state?.post)

  const [title, setTitle] = useState('Create Article')
  const [description, setDescription] = useState('')
  const [richTextContent, setRichTextContent] = useState('')
  const [cpTitle, setCpTitle] = useState('')
  const [cpQuestionId, setCpQuestionId] = useState('')
  const [selectedFiles, setSelectedFiles] = useState<any>([])
  const [from, setFrom] = useState('description')
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [isCaptionOpen, setIsCaptionOpen] = useState(false)
  const [successMsg, setSuccessMsg] = useState('')
  const [isMediaUpload, setIsMediaUpload] = useState(false)
  const [loaderStatus, setLoaderStatus] = useState('')
  const [isLoaderExternal, setIsLoaderExternal] = useState(false)
  const [totalItemsExternal, setTotalItemsExternal] = useState(0)
  const [handelTimeRender, setHandelTimeRender] = useState(false)
  const [mediaRecorderStatus, setMediaRecorderStatus] = useState('')
  const [isMediaPhone, setIsMediaPhone] = useState(false)
  const [showShareLink, setShowShareLink] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [authResponse, setAuthResponse] = useState<any>()

  // Article-specific state (always true for this component)
  const isArticleMode = true

  // Rich text editor configuration for articles
  const [quillModules] = useState({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false
    }
  })

  const [quillFormats] = useState([
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'script', 'indent', 'direction',
    'color', 'background', 'align', 'link', 'image'
  ])

  const [openPicker] = useDrivePicker()

  const handleOpenPicker = () => {
    openPicker({
      clientId: environment.googleDriveClientId,
      developerKey: environment.googleDriveDeveloperKey,
      viewId: 'DOCS',
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      callbackFunction: (data: any) => {
        if (data.action === 'cancel') {
          console.log('User clicked cancel/close button')
        } else if (data.action === 'picked') {
          setAuthResponse(data.authResponse)
          const files = data.docs.map((file: any) => ({
            ...file,
            from: 'google_drive',
            provider: 'external',
            type: file.mimeType.includes('image') ? 'image' : file.mimeType.includes('video') ? 'video' : 'file'
          }))
          setSelectedFiles([...selectedFiles, ...files])
        }
      },
    })
  }

  const openDropBox = () => {
    // Dropbox implementation
  }

  const openFileSelection = () => {
    document.getElementById('FileUploadFromSystem_input')?.click()
  }

  const systemFileSelection = (e: any) => {
    const files = Array.from(e.target.files).map((file: any) => ({
      name: file.name,
      size: file.size,
      type: file.type.includes('image') ? 'image' : file.type.includes('video') ? 'video' : 'file',
      file: file,
      url: URL.createObjectURL(file)
    }))
    setSelectedFiles([...selectedFiles, ...files])
  }

  const onEmojiClick = (emojiData: any) => {
    if (from === 'description') {
      setRichTextContent(richTextContent + emojiData.emoji)
    }
    setShowEmojiPicker(false)
  }

  const showMessage = (message: string) => {
    setSuccessMsg(message)
    setTimeout(() => {
      setSuccessMsg('')
    }, 3000)
  }

  const sendEmail = async (type: string) => {
    const data = JSON.stringify({
      to: userData.value?.data.email,
      subject: 'Upload link',
      html: `${environment.frontEndPoint}upload/${pageData.data._id}/${userData.value.data._id}/${type}`,
      pageId: pageData.data._id,
      type: 'upload',
    })
    const token = store.getState().user?.value?.token
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${environment.apiEndPoint}page/email/send`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data,
    }

    axios(config)
      .then(() => {
        showMessage('Email sent successfully')
        setShowShareLink(false)
        setIsMediaPhone(true)
      })
      .catch(() => {})
  }

  const handleFormSubmit = (e: any) => {
    e.preventDefault()
    createNewPost()
  }

  const createNewPost = () => {
    if (!richTextContent.trim() && selectedFiles.length === 0) {
      return
    }

    const mediaArr: any[] = []
    
    if (selectedFiles.length > 0) {
      uploadSelectedMedia()
      return
    }

    const payload: any = {
      title: cpTitle,
      description: richTextContent,
      page: pageData?.data?._id,
      medias: mediaArr,
      createdBy: userData?.value?.data?._id,
      reactions: [],
      questionId: cpQuestionId,
      isArticle: true, // Always true for articles
    }

    if (props?.editPost) {
      payload._id = props?.editPost?._id
      dispatch(updatePost(payload))
    } else {
      trackEvent('Page Interaction', 'Article Creation', 'Article')
      dispatch(createPost(payload))
    }
  }

  const uploadSelectedMedia = async () => {
    setIsMediaUpload(true)
    setLoaderStatus('Uploading media...')
    
    // Media upload logic here
    // This would be similar to the original CreatePost component
    // For brevity, I'm keeping this simplified
  }

  const removeSelectedFile = (pos: number) => {
    setSelectedFiles(
      selectedFiles?.filter((e: any, index: number) => {
        return pos !== index
      })
    )
  }

  const updateCaption = (index: number, caption: string) => {
    const updatedFiles = [...selectedFiles]
    updatedFiles[index].caption = caption
    setSelectedFiles(updatedFiles)
  }

  const IconHolder = () => {
    return (
      <div
        className={cn('IconHolder', {
          mediaIconsOnly: ismediapost,
        })}
      >
        <div className="lhs">
          {from === 'description' ? (
            <i
              className="fa fa-butterflysmiley"
              onClick={() => {
                setShowEmojiPicker(true)
              }}
            ></i>
          ) : (
            <></>
          )}
        </div>
        <div className="IconsList">
          {!ismediapost && (
            <i
              className={cn('fa fa-text', {
                active: from === 'description',
              })}
              onClick={() => {
                setFrom('description')
              }}
            ></i>
          )}
          <i
            className={cn('fa fa-butterflymedia', {
              active: from === 'media',
            })}
            onClick={() => {
              setFrom('media')
            }}
          ></i>
          <i
            className={cn('fa fa-videopost', {
              active: from === 'video',
            })}
            onClick={() => {
              setFrom('video')
            }}
          ></i>
          <i
            className={cn('fa fa-butterflymic mr-0', {
              active: from === 'micaudio',
            })}
            onClick={() => {
              setFrom('micaudio')
            }}
          ></i>
        </div>
      </div>
    )
  }

  const textDescription = () => {
    return (
      <>
        <input
          type="text"
          placeholder="Article Title"
          value={cpTitle}
          onChange={(e) => setCpTitle(e.target.value)}
          className="article-title-input"
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '18px',
            fontWeight: '600',
            border: '1px solid #ddd',
            borderRadius: '8px',
            marginBottom: '15px',
            outline: 'none'
          }}
        />
        <div className="rich-text-editor full-screen" onClick={(e) => e.stopPropagation()}>
          <ReactQuill
            value={richTextContent}
            onChange={setRichTextContent}
            modules={quillModules}
            formats={quillFormats}
            placeholder="Write your article content here..."
            theme="snow"
            preserveWhitespace={true}
          />
        </div>
        {from !== 'description' && (
          <i
            className="fa fa-butterflysmiley"
            onClick={() => {
              setShowEmojiPicker(true)
            }}
          ></i>
        )}
        {showEmojiPicker ? (
          <div className="Emojis">
            <p
              onClick={() => {
                setShowEmojiPicker(false)
              }}
            >
              &#x2715;
            </p>
            <Picker autoFocusSearch={false} onEmojiClick={onEmojiClick} />
          </div>
        ) : (
          ''
        )}
      </>
    )
  }

  useEffect(() => {
    if (postData?.postCreateResponse?.success === true) {
      setRichTextContent('')
      setIsCaptionOpen(false)
      setShowEmojiPicker(false)
      setSelectedFiles([])
      dispatch(loading(false))
      dispatch(addPageAction(''))
      props?.handleClose()
    }
  }, [postData?.postCreateResponse])

  useEffect(() => {
    if (props?.editPost) {
      setRichTextContent(props?.editPost?.description || '')
      setTitle('Edit Article')
      setCpTitle(props?.editPost?.title)
      setCpQuestionId(props?.editPost?.questionId)
    }
  }, [props?.editPost])

  useEffect(() => {
    if (postData?.updatePostResponse?.success === true) {
      setRichTextContent('')
      setIsCaptionOpen(false)
      setShowEmojiPicker(false)
      setSelectedFiles([])
      dispatch(loading(false))
      dispatch(addPageAction(''))
      props?.handleClose()
    }
  }, [postData?.updatePostResponse])

  useEffect(() => {
    if (props?.title) {
      props?.editPost?.title ? setTitle(props?.editPost?.title) : setTitle(props?.title)
    }
  }, [props?.title])

  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={() => {
          if (stopVideo.current) {
            stopVideo?.current?.click()
          }
          if (userData?.value?.data?.showStep) {
            dispatch(addPageAction('show-question-steps'))
          } else {
            addPageAction('')
          }
          props.handleClose()
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="CreatePost article-mode-modal"
        fullscreen={true}
      >
        {userData.loading && (
          <Loader
            status={loaderStatus}
            isActive={isMediaUpload}
            totalItems={selectedFiles.length > 0 ? selectedFiles.length : isLoaderExternal ? totalItemsExternal : 0}
            isExternal={isLoaderExternal}
          />
        )}
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {title ? title : props?.title ? props?.title : 'Create Article'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {successMsg !== '' ? (
            <div className="text text-center text-success">
              <span>{successMsg}</span>
            </div>
          ) : (
            <></>
          )}

          {from === 'description' ? (
            <form className="Message" onSubmit={handleFormSubmit}>
              <div className="MessagePost">
                {/* Article Title Input */}
                <input
                  type="text"
                  placeholder="Article Title"
                  value={cpTitle}
                  onChange={(e) => setCpTitle(e.target.value)}
                  className="article-title-input"
                  style={{
                    width: '100%',
                    padding: '12px',
                    fontSize: '18px',
                    fontWeight: '600',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    marginBottom: '15px',
                    outline: 'none'
                  }}
                />

                {/* Rich Text Editor for Article Content */}
                <div className="rich-text-editor full-screen" onClick={(e) => e.stopPropagation()}>
                  <ReactQuill
                    value={richTextContent}
                    onChange={setRichTextContent}
                    modules={quillModules}
                    formats={quillFormats}
                    placeholder="Write your article content here..."
                    theme="snow"
                    preserveWhitespace={true}
                  />
                </div>
                {/* <React.Fragment>{IconHolder()}</React.Fragment> */}
              </div>
            </form>
          ) : from === 'media' ? (
            <>
              {/* {!isMediaPhone && !showShareLink ? (
                <form className="Image">
                  <div className="ImagePost">
                    {!ismediapost && <React.Fragment>{textDescription()}</React.Fragment>}
                    <div className={selectedFiles?.length === 0 ? 'UploadSec' : 'UploadSec d-none'}>
                      <div className="IconHolder">
                        <div className="EachIconHolder" onClick={openFileSelection}>
                          <img src={folder} />
                          <span>{isMobile ? 'Folder' : 'Computer'}</span>
                          <input
                            type="file"
                            className="d-none"
                            id="FileUploadFromSystem_input"
                            accept="image/*"
                            multiple
                            onChange={systemFileSelection}
                          />
                        </div>
                        <div className="EachIconHolder" onClick={handleOpenPicker}>
                          <img src={GDrive} className="gDrive" />
                          <span>
                            Google Drive<sup>TM</sup>
                          </span>
                        </div>
                        <div
                          className="EachIconHolder"
                          onClick={() => {
                            openDropBox()
                          }}
                        >
                          <img src={dropbox} className="dropbox" />
                          <span>Dropbox</span>
                        </div>
                        <div
                          className="EachIconHolder"
                          onClick={() => {
                            setIsMediaPhone(true)
                          }}
                        >
                          <img src={phone} className="phone" />
                          <span>Phone</span>
                        </div>
                      </div>
                    </div>
                    {selectedFiles?.length ? (
                      <div>
                        {!isCaptionOpen ? (
                          <>
                            <span
                              className="addCapt"
                              onClick={() => {
                                setIsCaptionOpen(true)
                              }}
                            >
                              <i className="fa fa-plus"></i> Add captions to photos
                            </span>
                            <div className="SelectedImages">
                              {selectedFiles?.map((element: any, key: number) => {
                                return (
                                  <div className="EachImageHolder" key={key}>
                                    <img src={element?.url} alt="" />
                                    <span
                                      onClick={() => {
                                        removeSelectedFile(key)
                                      }}
                                    >
                                      <i className="fa fa-butterflydelete"></i>
                                    </span>
                                  </div>
                                )
                              })}
                            </div>
                            <span className="addCapt">
                              Add more photos:{' '}
                              <span className="folder" onClick={openFileSelection}>
                                <img src={folder} />
                              </span>
                              <span className="g-drive" onClick={handleOpenPicker}>
                                <img src={GDrive} className="gDrive" />
                              </span>
                              <span
                                className="dropbox"
                                onClick={() => {
                                  openDropBox()
                                }}
                              >
                                <img src={dropbox} />
                              </span>
                              {!isMobile ? (
                                <span
                                  className="phone"
                                  onClick={() => {
                                    setIsMediaPhone(true)
                                  }}
                                >
                                  <img src={phone} className="phone" />
                                </span>
                              ) : (
                                ''
                              )}
                            </span>
                          </>
                        ) : (
                          <>
                            <span
                              className="addCapt"
                              onClick={() => {
                                setIsCaptionOpen(false)
                              }}
                            >
                              <i className="fa fa-chevron-small-left"></i> Back to photos
                            </span>
                            <div className="Caption">
                              {selectedFiles?.map((element: any, key: number) => {
                                return (
                                  <div className="Eachcaption" key={key}>
                                    <div className="Images">
                                      <img src={element?.url} alt="" />
                                    </div>
                                    <div className="TextField">
                                      <textarea
                                        placeholder="Captions are a great way to tell more of the story in a personal way."
                                        value={element.caption}
                                        id={'post_caption_' + key}
                                        onChange={(e: any) => {
                                          updateCaption(key, e?.target?.value)
                                        }}
                                      ></textarea>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  {selectedFiles.length === 0 && <React.Fragment>{IconHolder()}</React.Fragment>}
                </form>
              ) : (
                ''
              )} */}
            </>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            id="submit-article"
            disabled={!richTextContent.trim() && selectedFiles.length === 0}
            onClick={createNewPost}
          >
            {props?.editPost ? 'Save' : 'Publish'}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CreateArticle
